export function getCurrentResponsiveView() {
  try {
    return window.matchMedia("(min-width: 700px)").matches ? "tablet" : "mobile";
  } catch (error) {
    return "mobile";
  }
}

export function withMobileView(target) {
  if (!target || typeof target !== "string" || !target.startsWith("/")) {
    return target;
  }

  try {
    const nextUrl = new URL(target, window.location.origin);
    nextUrl.searchParams.delete("view");
    nextUrl.searchParams.delete("device");
    nextUrl.searchParams.delete("preview");
    return `${nextUrl.pathname}${nextUrl.search}${nextUrl.hash}`;
  } catch (error) {
    return target
      .replace(/([?&])(view|device|preview)=(mobile|tablet|app|pc|web)&?/g, "$1")
      .replace(/[?&]$/, "");
  }
}

export function navigateMobile(navigate, target, options) {
  const nextTarget = withMobileView(target);
  if (typeof navigate === "function") {
    navigate(nextTarget, options);
  }
}
